import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { handlePutRequest } from '../../../service/PutTemplate';
import { useDispatch } from 'react-redux';
import { endPoints } from '../../../Config';
import { handleGetRequest } from '../../../service/GetTemplate';
import { Dialog } from 'primereact/dialog';
import EditViewDisbursement from './EditViewDisbursementFee';
import EditViewTransactionFee from '../Merchant Fee Report/EditViewTransactionFee';


const TransactionFee = () => {
    const [expandedRows, setExpandedRows] = useState(null);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allMerchants, setAllMerchants] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [switchData, setSwitchData] = useState(null);
    const [switchModal, setSwitchModal] = useState(false);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();
    const dummyData = [
        { label: 'Rast', value: 'Rast' },
        { label: '1 Link', value: '1 Link' },
        { label: 'Acc To Acc', value: 'Acc To Acc' },
        { label: 'Credit/Debit', value: 'Credit/Debit' },
        { label: 'International Card', value: 'International Card' }
    ];
    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
   
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };
    const handleInputSwitch = async () => {
        setLoadingBtn(true);

        let data = {
            isActive: switchData?.isActive ? false : true
        };

        const response = await dispatch(handlePutRequest(data, endPoints?.updateMerchant, false, true));

        if (response?.status === 200) {
            getMerchantList();
        }

        setLoadingBtn(false);
        handleSwitchModalClose();
    };

    const handleSwitchModalOpen = () => {
        setSwitchModal(true);
    };

    const handleSwitchModalClose = () => {
        setSwitchModal(false);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        onClick={() => {
                            handleEdit(rowData);
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    <Button
                        tooltip="View Details"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            handleView(rowData);
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    const getMerchantList = async () => {
        const response = await handleGetRequest(endPoints.getallMerchants, true, false, dispatch);
        if (response) {
            setAllMerchants(response?.data);
        }
    };

    useEffect(() => {
        getMerchantList();
    }, []);

    const onHide = () => {
        setShowAddDialog(false);
        getMerchantList();
    };
    const onCancel = () => {
        setShowAddDialog(false);
    };
    const onClose = () => {
        setShowAddDialog(false);
    };

    const rowExpansionTemplate = (parentRowData) => {
        return (
            <DataTable value={dummyData}>
                <Column field="label" header="Transaction Type" />

                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        );
    };

    const allowExpansion = (rowData) => {
        return <>{rowData.length > 0}</>;
    };
    return (
        <>
            <Dialog header={<div>{editable ? 'Edit Transaction Fee' : 'View Transaction Fee'}</div>} visible={showAddDialog} onHide={onClose} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
            
                <EditViewTransactionFee rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onClose={onClose} />
            </Dialog>

            <DataTable
                expandedRows={expandedRows}
                rowExpansionTemplate={rowExpansionTemplate}
                onRowToggle={(e) => {
                    setExpandedRows(e.data);
                }}
                filter
                rows={5}
                value={allMerchants}
                responsiveLayout="scroll"
                paginator
                key="_id"
            >
                <Column expander={allowExpansion} style={{ width: '3em' }} />
                <Column field="ownerName" header="POC Name" />
                <Column field="ownerEmail" header="POC Email" />
                <Column field="companyName" header="Company Name" />
                <Column field="companyEmail" header="Company Email" />
            </DataTable>
        </>
    );
};

export default TransactionFee;
